import { SFOCFleetDashboardViewComponent } from "src/views/SFOCFleetDashboardView/SFOCFleetDashboardViewComponent";

export const SFOCFleetDashboardViewContainer = SFOCFleetDashboardViewComponent;
export default SFOCFleetDashboardViewContainer;
